import "core-js/modules/es6.object.assign";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}
/*
Copyright (c) 2018-2019 Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
// BASEUI-GENERATED-FLAG-COMPONENT
// DO NOT EDIT THIS FILE DIRECTLY


import * as React from 'react';
export default function FlagRS(props) {
  return React.createElement("img", _extends({
    src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD8AAAAtCAMAAAAun0N9AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAABLUExURff39889RRNIgP7+/t5CS9Y/SMg5QfPy8hFDefv7+xVMhxVOixZPjtGjOnGMrtB4PuWqru/i5M9cYuzLzdeAhVRGbShXjJw9Uai91VbISlgAAAHTSURBVEjHxZSLloIgEIYHENA0xeyy7/+kO8OgAVJR7Tn7MTLM5UcTT9B8B/y7XnuvvbHTaxRm/dB0A5ppvAXf6BDFtdDRpEmIGws0L7KgvwO0WAdN96g8dj0gBKfJNrbmEEWFDEgiPeE0Hf0sqkj1pD0SvEeV3hhhBBr740qWJ09kOQFmrTCRPsmz1OyALN70po5cPwX5VKsfUn46RXQ/Qx0w9J6h9+HFKcZd+g2q9UN5DX3CzSxevphbXwUcYlAv5k51szC3QxWJvr/iCZ1Qf8LTut7T3u7+of4wLvhKZzXjvIxxQT6+v/RFnNHGzuGRKGuMgzHkuEFufetaegMZMwKcDT6/OQOMsoZEf0C9PVmFF3Qf6KXX4+9H/Rv3b7dxped3ytHzX32d8zJcydobtAkzvr+TxeNzc/sC3iDVyxFP7mzPOI9Zr7/ayDPZ/S90e0sPcGmryPQtfr+ox++3rdSrFLdYYnGqjlyvLKNq9fh/gR/chuoA1ZgNg43/U/I1AUHFcbRRtGNhrdYACopysgwAtQNCjtcFD6EjxH6xprkEu3Xs43oe7Uvdy9YnO7yJ3Rle6YhSbFGSJhumYHHae8sVKNRpxeUnwIe1F8CXevsX+l+iMj8P93XJ1wAAAABJRU5ErkJggg==",
    alt: "RS"
  }, props));
}